
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'CampaignSignUp',

  computed: {
    backgroundStyle() {
      const style: {
        backgroundImage?: string
      } = {};

      if (this.$store.state.campaign?.pictureUrl) {
        style.backgroundImage = `url(${(this.$store.state.campaign.pictureUrl)})`;
      }

      return style;
    },
  },

  mounted() {
    this.$router.beforeEach(() => {
      this.scrollToTop();
    });
  },

  methods: {
    scrollToTop() {
      (this.$refs.signUpHolder as HTMLDivElement).scrollTop = 0;
    },
  },
});
